module.exports = __webpack_public_path__ + "static/media/mtns-lake-transparent.8a67784b.png";